import "@designsystem/styles/dist/main";
/**
 * Primary UI component for user interaction
 */
export function MainStyle() {
    return (<></>);
}
